<template>
  <header id="site-header" class="site-header" :class="{ open: isOpen }">
    <div class="content-full-width flex">
      <nav>
        <a :class="{ hide: isHome }" href="/">
          <img src="/images/nav-logo.png" alt="" />
        </a>
        <button
          class="burger"
          :class="{ 'nav-active': isOpen, internal: !isHome }"
          @click="toggleMenu()"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>
    </div>
    <!-- Toggles on burger -->
    <MobileNav :open="isOpen" />
  </header>
</template>

<script>
import MobileNav from "./utils/MobileNav";

export default {
  props: ["csrf", "data", "logged_in", "slug", "navigation"],
  components: {
    MobileNav,
  },
  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggleMenu() {
      const body = document.querySelector("body");
      body.classList.toggle("overflow-hidden");
      this.isOpen = !this.isOpen;
    },

    logout() {
      window.axios
        .post("/logout", { token: this.csrf })
        .then((response) => {
          window.location.href = "/";
        })
        .catch((error) => {});
    },
  },
  computed: {
    isHome() {
      if (this.slug === "home" && !this.isOpen) {
        return true;
      }
      return false;
    },
  },
};
</script>


<style lang="scss" scoped>
.hide {
  opacity: 0;
}
nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
img {
  width: 211px;

  @media (min-width: 1024px) {
    transform: translate(-10px, 5px);
  }
}

.burger.internal {
  span {
    background-color: #3b3b3b;
  }
}

.burger.nav-active {
  span {
    background-color: #0E7F86;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue